import React, { useEffect, useState } from "react";
import { roundOffCost } from "../../../Components/Functions/amt.fun";

const ProduceBreakevenTable = ({ allQData }) => {
  const [nftAData, setnftAData] = useState();
  const [fbData, setfbData] = useState();
  const [gbData, setgbData] = useState();
  const [dbData, setdbData] = useState();

  useEffect(() => {
    let nftA = [];
    let gb = [];
    let db = [];
    let fb = [];
    allQData?.plant_grow?.updatedPlantsList?.map((el) => {
      if (el?.grow_system === "gb") {
        gb.push(el);
      }
      if (el?.grow_system === "db") {
        db.push(el);
      }
      if (el?.grow_system === "fb") {
        fb.push(el);
      }
      if (el?.grow_system === "nftA") {
        nftA.push(el);
      }
    });
    if (nftA.length > 0) {
      setnftAData(nftA);
    }
    if (gb.length > 0) {
      setgbData(gb);
    }
    if (db.length > 0) {
      setdbData(db);
    }
    if (fb.length > 0) {
      setfbData(fb);
    }
  }, [allQData]);

  const style = {
    border: "1px solid #181818",
    textAlign: "left",

    borderCollapse: "collapse",
    padding: "2px",
  };

  function roundUp(cost) {
    cost = Math.ceil(cost);
    return cost;
  }
  const getRevenue = (price, plant) => {
    let harvest = 0;

    switch (plant?.grow_system) {
      case "nftA":
        harvest =
          plant.productionPerPlantMonth *
          allQData?.number_of_plants?.numberOfPlantsInA_Frame;
        break;

      case "fb":
        harvest =
          plant.productionPerPlantMonth *
          allQData?.number_of_plants?.numberOfPlantsInFlatBed;
        break;

      case "gb":
        harvest =
          plant.productionPerPlantMonth *
          allQData?.number_of_plants?.numberOfPlantsInGrowBag;
        break;

      case "db":
        harvest =
          plant.productionPerPlantMonth *
          allQData?.number_of_plants?.numberOfPlantsInDutchBucket;
        break;

      default:
        harvest = 0;
    }

    // Round once and use everywhere
    harvest = roundUp(harvest);

    return price * harvest;
  };
  return (
    <div>
      <h3>Plants you can grow</h3>
      {nftAData && nftAData.length > 0 && (
        <>
          <h3 className="text-uppercase">
            NFT A-Frame -{" "}
            <span style={{ color: "green" }}>
              {allQData?.number_of_plants?.numberOfPlantsInA_Frame} plants
            </span>
          </h3>
          <table style={{ width: "100%", ...style }}>
            <thead>
              <tr>
                <th style={{ width: "3%", ...style }}>Sr.</th>
                <th style={{ ...style, width: "15%" }}>Crop</th>
                <th style={{ ...style, width: "10%" }}>Harvest (Mo)</th>
                <th style={style}>Price (Min-Max)</th>
                <th style={style}>Revenue (Min-Max)</th>
                <th style={{ ...style, width: "15%" }}>Revenue (Avg)</th>
                {nftAData[0]?.companyName && (
                  <th style={{ ...style, width: "15%" }}>Recommended Seeds</th>
                )}
              </tr>
            </thead>
            <tbody>
              {nftAData &&
                nftAData.map((plant, index) => {
                  return (
                    <tr style={style} key={index}>
                      <td style={style}>{++index}</td>
                      <td style={style}>{plant?.plantName}</td>
                      <td style={style}>
                        {roundUp(
                          plant?.productionPerPlantMonth *
                            allQData?.number_of_plants?.numberOfPlantsInA_Frame
                        )}
                        kg
                      </td>

                      <td style={style}>
                        {roundOffCost(plant?.min_price)} -{" "}
                        {roundOffCost(plant?.max_price)}
                      </td>

                      <td style={style}>
                        {roundOffCost(getRevenue(plant?.min_price, plant))} -{" "}
                        {roundOffCost(getRevenue(plant?.max_price, plant))}
                      </td>

                      <td style={style}>
                        {roundOffCost(
                          (getRevenue(plant?.min_price, plant) +
                            getRevenue(plant?.max_price, plant)) /
                            2
                        )}
                      </td>
                      {plant?.companyName && (
                        <td style={style}>{plant?.companyName}</td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      )}
      {fbData && fbData.length > 0 && (
        <>
          <h3 className="text-uppercase">
            Flat Bed -{" "}
            <span style={{ color: "green" }}>
              {allQData?.number_of_plants?.numberOfPlantsInFlatBed} plants
            </span>
          </h3>
          <table style={{ width: "100%", ...style }}>
            <thead>
              <tr>
                <th style={{ width: "3%", ...style }}>Sr.</th>
                <th style={{ ...style, width: "15%" }}>Crop</th>
                <th style={{ ...style, width: "10%" }}>Harvest (Mo)</th>
                <th style={style}>Price (Min-Max)</th>
                <th style={style}>Revenue (Min-Max)</th>
                <th style={{ ...style, width: "15%" }}>Revenue (Avg)</th>
                {fbData[0]?.companyName && (
                  <th style={{ ...style, width: "15%" }}>Recommended Seeds</th>
                )}
              </tr>
            </thead>
            <tbody>
              {fbData &&
                fbData.map((plant, index) => {
                  return (
                    <tr style={style} key={index}>
                      <td style={style}>{++index}</td>
                      <td style={style}>{plant?.plantName}</td>
                      <td style={style}>
                        {roundUp(
                          plant?.productionPerPlantMonth *
                            allQData?.number_of_plants?.numberOfPlantsInFlatBed
                        )}
                        kg
                      </td>

                      <td style={style}>
                        {roundOffCost(plant?.min_price)} -{" "}
                        {roundOffCost(plant?.max_price)}
                      </td>

                      <td style={style}>
                        {roundOffCost(getRevenue(plant?.min_price, plant))} -{" "}
                        {roundOffCost(getRevenue(plant?.max_price, plant))}
                      </td>

                      <td style={style}>
                        {roundOffCost(
                          (getRevenue(plant?.min_price, plant) +
                            getRevenue(plant?.max_price, plant)) /
                            2
                        )}
                      </td>
                      {plant?.companyName && (
                        <td style={style}>{plant?.companyName}</td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      )}
      {gbData && gbData.length > 0 && (
        <>
          <h3 className="text-uppercase">
            {allQData?.input_info?.isGrowSlab ? "Grow Slab" : "Grow Bag"} -{" "}
            <span style={{ color: "green" }}>
              {allQData?.number_of_plants?.numberOfPlantsInGrowBag} plants
            </span>
          </h3>
          <table style={{ width: "100%", ...style }}>
            <thead>
              <tr>
                <th style={{ width: "3%", ...style }}>Sr.</th>
                <th style={{ ...style, width: "15%" }}>Crop</th>
                <th style={{ ...style, width: "10%" }}>Harvest (Mo)</th>
                <th style={style}>Price (Min-Max)</th>
                <th style={style}>Revenue (Min-Max)</th>
                <th style={{ ...style, width: "15%" }}>Revenue (Avg)</th>
                {gbData[0]?.companyName && (
                  <th style={{ ...style, width: "15%" }}>Recommended Seeds</th>
                )}
              </tr>
            </thead>
            <tbody>
              {gbData &&
                gbData.map((plant, index) => {
                  return (
                    <tr style={style} key={index}>
                      <td style={style}>{++index}</td>
                      <td style={style}>{plant?.plantName}</td>
                      <td style={style}>
                        {roundUp(
                          plant?.productionPerPlantMonth *
                            allQData?.number_of_plants?.numberOfPlantsInGrowBag
                        )}
                        kg
                      </td>

                      <td style={style}>
                        {roundOffCost(plant?.min_price)} -{" "}
                        {roundOffCost(plant?.max_price)}
                      </td>

                      <td style={style}>
                        {roundOffCost(getRevenue(plant?.min_price, plant))} -{" "}
                        {roundOffCost(getRevenue(plant?.max_price, plant))}
                      </td>

                      <td style={style}>
                        {roundOffCost(
                          (getRevenue(plant?.min_price, plant) +
                            getRevenue(plant?.max_price, plant)) /
                            2
                        )}
                      </td>
                      {plant?.companyName && (
                        <td style={style}>{plant?.companyName}</td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      )}
      {dbData && dbData.length > 0 && (
        <>
          <h3 className="text-uppercase">
            Dutch Bucket -{" "}
            <span style={{ color: "green" }}>
              {allQData?.number_of_plants?.numberOfPlantsInDutchBucket} plants
            </span>
          </h3>
          <table style={{ width: "100%", ...style }}>
            <thead>
              <tr>
                <th style={{ width: "3%", ...style }}>Sr.</th>
                <th style={{ ...style, width: "15%" }}>Crop</th>
                <th style={{ ...style, width: "10%" }}>Harvest (Mo)</th>
                <th style={style}>Price (Min-Max)</th>
                <th style={style}>Revenue (Min-Max)</th>
                <th style={{ ...style, width: "15%" }}>Revenue (Avg)</th>
                {dbData[0]?.companyName && (
                  <th style={{ ...style, width: "15%" }}>Recommended Seeds</th>
                )}
              </tr>
            </thead>
            <tbody>
              {dbData &&
                dbData.map((plant, index) => {
                  return (
                    <tr style={style} key={index}>
                      <td style={style}>{++index}</td>
                      <td style={style}>{plant?.plantName}</td>
                      <td style={style}>
                        {roundUp(
                          plant?.productionPerPlantMonth *
                            allQData?.number_of_plants
                              ?.numberOfPlantsInDutchBucket
                        )}
                        kg
                      </td>

                      <td style={style}>
                        {roundOffCost(plant?.min_price)} -{" "}
                        {roundOffCost(plant?.max_price)}
                      </td>

                      <td style={style}>
                        {roundOffCost(getRevenue(plant?.min_price, plant))} -{" "}
                        {roundOffCost(getRevenue(plant?.max_price, plant))}
                      </td>

                      <td style={style}>
                        {roundOffCost(
                          (getRevenue(plant?.min_price, plant) +
                            getRevenue(plant?.max_price, plant)) /
                            2
                        )}
                      </td>
                      {plant?.companyName && (
                        <td style={style}>{plant?.companyName}</td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      )}

      {/* <% end %> */}
      <p>
        <strong>Terms & conditions:</strong>
        Total number of plants and tank capacity calculations are tentetive.
        Actual numbers are based on customization of project. Electricity cost
        is taken average of agriculture cost across India and it can vary based
        on your location. Opex specifications can vary as per your location.
        Pricing of crops is considered average collected from various sources
        from Price-Watcher. Plant growth estimates are based on ideal conditions
        and agronomy practices by a qualified agronomist. Agriculture in general
        is subject to infections, pests and other uncontrollable factors. KBPL
        is not responsible for any financial losses or gains from the above
        estimates. KBPL strongly recommends that you conduct your own
        independent market research. Above numbers are only estimates and actual
        results may vary as per the crop, location, weather, farm management,
        etc.
      </p>
    </div>
  );
};

export default ProduceBreakevenTable;
